export type AdditionalContactDataField =
  | 'company'
  | 'address'
  | 'city'
  | 'postalcode'
  | 'country'
  | 'fullname';

export const widgetSupportedLanguageKeys = [
  'en',
  'en-GB',
  'nl',
  'cs',
  'sk',
  'it',
  'de',
  'fr-CA',
  'fr',
  'da',
  'es',
  'fi',
  'hr',
  'ja',
  'ko',
  'no', 'nb', 'nn',
  'pt',
  'sr',
  'sv',
  'tr',
  'zh',
  'ca',
  // 'hu',
  'pl',
] as const;

export type WidgetNoAvailabilityCustomMessage = 'no-online' | 'please-call';

export interface WidgetSettings {

  accessKey?: string;

  // if defined, it will select this account id from multi widget access key.
  accountId?: number;

  // if undefined, color is taken from account settings
  color?: string;

  //
  useHtmlLanguage?: boolean;

  // used to override the language of the widget. If undefined, we use restaurant language
  locale?: string;

  // when true, widget is placed in the center of the screen and is not dismissable.
  fullPage?: boolean;

  // Show terms and conditions check box in booking form
  useTerms?: boolean;

  // Custom T&C link
  useTermsUrl?: string;

  // Show newsletter subscription checkbox
  useNewsletterSubscription?: boolean;

  // When true, newsletter consent box will be ticked by default
  useNewsletterSubscriptionOptIn?: boolean;

  // Hide floating button
  showFab?: boolean;

  // Hide floating button for gift cards
  showGiftCardFab?: boolean;

  // opens automatically on desktop
  open?: boolean;

  // override the floating button text
  fabText?: string;

  // hide group booking link in partysize picker
  useMaxPartySizeLink?: boolean;

  // Translation strings that can override any default translation key path
  t9n?: any;

  // show extra step with party size breakdown before booking form
  usePartySizeBreakdown?: boolean;

  // show extra step with party size breakdown and child seats count before booking form
  usePartySizeChildSeatsBreakdown?: boolean;

  // extra contact fields in form
  additionalContactData?: AdditionalContactDataField[];

  // if false, reservation note field is hidden
  useReservationNotes?: boolean;

  // if false, restaurant phone number is hiden from More People dialog
  useRestaurantPhone?: boolean;

  // if false, restaurant email is hiden from More People dialog
  useRestaurantEmail?: boolean;

  // referral, code that will be set to tracking in dataLayer
  referral?: string;

  // Custom messages for fully booked, no availability and closed states
  messageFullyBooked?: WidgetNoAvailabilityCustomMessage;

  messageNoAvailability?: WidgetNoAvailabilityCustomMessage;

  messageClosed?: WidgetNoAvailabilityCustomMessage;
}
